import { GridApi, GridReadyEvent, Module } from '@ag-grid-community/core';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, takeUntil } from 'rxjs';
import { SkuCellRendererComponent } from 'src/app/ag-grid-components/sku-cell-renderer/sku-cell-renderer.component';
import { DialogActions } from 'src/app/components/dialogs/dialog.model';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { SmartGridBaseConfigService } from 'src/app/data-grid/smart-grid-base-config.service';
import { InventoryService } from 'src/app/services/inventory.service';

@Component({
  selector: 'app-product-tag-grid',
  templateUrl: './product-tag-grid.component.html',
  styleUrls: ['./product-tag-grid.component.scss']
})
export class ProductTagGridComponent implements OnInit, OnDestroy {
  gridApi: GridApi;
  modules: Module[] = [ServerSideRowModelModule];
  columnDefs= [{
    headerName: "Sku",
    field: "Sku",
    cellRenderer: "skuCellRendererComponent",
    width: "500"
  },
  {
    headerName: "Sku’s QTY",
    field: "qty",
  },
  {
    headerName: "Initial suggested QTY",
    field: "suggestedQty"
  }
  ]  
  private destroy$ = new Subject<void>();
  gridOptions = {
    ...this.settingGridConfigService.gridOptions,
    components: {
      skuCellRendererComponent: SkuCellRendererComponent,
    },
    onGridReady: (e) => {
      this.gridApi = e.api;
      this.getProduct();
    },
  };
  actions: DialogActions[] = [ { text: "Close",}];
  rowData: any = [];
  
  constructor(private settingGridConfigService: SmartGridBaseConfigService,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ProductTagGridComponent>,
    private inventoryService: InventoryService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.createGrid();
  }
  
  action(e) {
    this.dialogRef.close();
  }
  
  onGridReady (e) {
    this.gridApi = e.api;
   // this.getProduct();
  }

  getProduct() {
    this.inventoryService.getTagProduct().pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        if (res) {
          this.gridApi.setGridOption('rowData',res);
          this.gridApi.sizeColumnsToFit();
        }
      },
     error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
   });
  }

  createGrid(): void {
    this.gridOptions.rowHeight = 56;
    this.gridOptions.headerHeight = 26;
    this.gridOptions.rowSelection = 'multiple';
    this.gridOptions.suppressMovableColumns = true;
    this.gridOptions.onGridReady = (params: GridReadyEvent) => {
      this.gridApi = params.api;
      this.gridApi.sizeColumnsToFit();
      this.getProduct();
    };
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
